export default __webpack_public_path__ + "a8371d37a7cb682e49666a27355ec1eb.png";